function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 15 19"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M11.259 12L7.943 8.684a.949.949 0 010-1.339.944.944 0 011.34 0l4.914 4.914a.945.945 0 01.273.739.945.945 0 01-.273.739l-4.914 4.914a.944.944 0 01-1.34 0 .949.949 0 010-1.34L11.254 14H5a5 5 0 01-5-5V1a1 1 0 012 0v8a3 3 0 003 3h6.259z",
  fill: "currentColor"
})));